import { useMemo } from "react";

import { captureDeeplinkPromoCode, getStoredDeeplinkPromoCode } from "@utils";

/**
 * The promo code the tab landed on, whether it arrived as `?promoCode=` or as a prefixed OneLink
 * `deep_link_value`.
 *
 * Startup captures it, because the entry flow navigates away from the landing URL before the email
 * screen renders and the query string does not survive that. The capture runs again here as a
 * fallback, for a screen reached directly on a URL that still carries the code.
 */
export const useDeeplinkPromoCode = () => {
  return useMemo(() => getStoredDeeplinkPromoCode() ?? captureDeeplinkPromoCode(), []);
};
